"use client"

import React, { createContext, useContext } from "react"

import useSiteHeaderHeight from "@packages/web/hooks/use-site-header-height"

import DashboardShell from "./DashboardShell"
import Header from "./Header"
import Footer from "./Footer"

const HolygrailChromeContext = createContext(false)

export default function Holygrail({
  children,
  noBacklink,
  noFooter,
  noHeader,
  withSidebar,
}: {
  children: React.ReactNode
  noBacklink?: boolean
  noFooter?: boolean
  noHeader?: boolean
  /** Dashboard chrome: desktop sidebar + mobile hamburger header. */
  withSidebar?: boolean
}) {
  const nested = useContext(HolygrailChromeContext)

  useSiteHeaderHeight(withSidebar ? undefined : noHeader ? "0px" : "64px")

  if (nested) {
    return <>{children}</>
  }

  if (withSidebar) {
    return (
      <HolygrailChromeContext.Provider value={true}>
        <DashboardShell>{children}</DashboardShell>
      </HolygrailChromeContext.Provider>
    )
  }

  /** Landing / auth-style pages: one viewport, no nested min-height scroll. */
  const fullBleed = noHeader && noFooter

  return (
    <HolygrailChromeContext.Provider value={true}>
      <div
        className={
          fullBleed
            ? "flex h-dvh w-full flex-col overflow-hidden bg-background/90"
            : "flex min-h-screen w-full flex-col bg-background/90"
        }
      >
        {!noHeader && <Header noBacklink={noBacklink} />}
        <main
          className={
            fullBleed
              ? "min-h-0 w-full flex-1 overflow-hidden bg-background/90"
              : `min-h-0 flex-1 w-full overflow-y-auto bg-background/90 ${noHeader ? "" : "pt-header"}`
          }
        >
          {children}
        </main>
        {!noFooter && <Footer />}
      </div>
    </HolygrailChromeContext.Provider>
  )
}
